export class MigrationConstants {
	public static readonly PREPARE_FOR_MIGRATION_LINK = 'https://onvio.us/ua/help/us-en/staff/core/migrations/prepare-for-migration.htm';

	private constructor() {
	}
}
